// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select_wrap__EZXnk {
  position: relative;
  width: 100%;
}

.Select_control__cFvYI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  border-radius: 10px;
  cursor: pointer;
  font-family: var(--font-sans);
  font-size: 14px;
  color: var(--dylo-ink);
  text-align: left;
}
.Select_control__cFvYI:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.Select_open__nJ2M8 .Select_control__cFvYI {
  border-color: var(--dylo-teal-500);
}
.Select_placeholder__mHE91 {
  color: var(--dylo-muted);
}
.Select_value__R-nOD {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Select_right__JxoS3 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: var(--dylo-field-icon);
}
.Select_clear__\\+sbCE {
  border: none;
  background: none;
  color: var(--dylo-field-icon);
  cursor: pointer;
  display: inline-flex;
  padding: 2px;
  border-radius: 4px;
}
.Select_clear__\\+sbCE:hover {
  color: var(--dylo-ink);
}
.Select_chevron__zogbu {
  transition: transform 0.15s ease;
}
.Select_open__nJ2M8 .Select_chevron__zogbu {
  transform: rotate(180deg);
}
.Select_spinner__I9vi\\+ {
  width: 14px;
  height: 14px;
  border: 2px solid var(--dylo-line);
  border-top-color: var(--dylo-teal-700);
  border-radius: 50%;
  animation: Select_sel-spin__Ux4\\+X 0.7s linear infinite;
}
@keyframes Select_sel-spin__Ux4\\+X {
  to { transform: rotate(360deg); }
}

.Select_menu__4TqVa {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: 10px;
  box-shadow: var(--shadow-card);
  z-index: 40;
  overflow: hidden;
  transform-origin: top center;
  animation: Select_dylo-dropdown__gAlzZ 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@media (prefers-reduced-motion: reduce) {
  .Select_menu__4TqVa { animation: none; }
}
.Select_search__kB4Cj {
  width: 100%;
  border: none;
  border-bottom: 1px solid var(--dylo-line);
  padding: 9px 12px;
  background: transparent;
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  font-size: 13.5px;
  outline: none;
}
.Select_list__Yluhs {
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.Select_list__Yluhs::-webkit-scrollbar {
  width: 6px;
}
.Select_list__Yluhs::-webkit-scrollbar-track {
  background: transparent;
}
.Select_list__Yluhs::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.Select_list__Yluhs::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);
}
.Select_option__Uivtz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border: none;
  background: transparent;
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 13.5px;
  cursor: pointer;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  animation: Select_dylo-fade-in__VRT7I 0.22s ease both;
}
.Select_option__Uivtz:nth-child(1) { animation-delay: 0.02s; }
.Select_option__Uivtz:nth-child(2) { animation-delay: 0.04s; }
.Select_option__Uivtz:nth-child(3) { animation-delay: 0.06s; }
.Select_option__Uivtz:nth-child(4) { animation-delay: 0.08s; }
.Select_option__Uivtz:nth-child(5) { animation-delay: 0.10s; }
.Select_option__Uivtz:nth-child(6) { animation-delay: 0.12s; }
.Select_option__Uivtz:nth-child(7) { animation-delay: 0.14s; }
.Select_option__Uivtz:nth-child(8) { animation-delay: 0.16s; }
@media (prefers-reduced-motion: reduce) {
  .Select_option__Uivtz { animation: none; }
}
.Select_option__Uivtz:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);
}
.Select_option__Uivtz > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
}
.Select_optionActive__eX-ae {
  color: var(--dylo-orange);
  font-weight: 600;
}

/* Opción visible pero no seleccionable (ej. proveedor sin acceso todavía) */
.Select_optionDisabled__df7vy {
  opacity: 0.5;
  cursor: not-allowed;
}
.Select_optionDisabled__df7vy:hover {
  background: transparent;
}
.Select_optionHint__ouMbu {
  flex: none;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid var(--dylo-line);
  color: var(--dylo-muted);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* Tono de aviso: para lo que sí funciona normalmente y está apagado AHORA.
   En gris se confunde con "nunca estuvo disponible", y esa lectura manda a pedir
   credenciales en lugar de revisar el interruptor.
   ⚠️ La opacidad del renglón deshabilitado (0.5) apaga cualquier color, así que el
   naranja se refuerza aquí para que siga leyéndose. */
.Select_optionHintWarn__-YcRZ {
  border-color: var(--dylo-orange);
  background: color-mix(in srgb, var(--dylo-orange) 14%, transparent);
  color: var(--dylo-orange);
  opacity: 1;
}
.Select_empty__XJeeZ {
  padding: 12px;
  text-align: center;
  color: var(--dylo-muted);
  font-size: 13px;
}

.Select_addRow__9yYde {
  border-top: 1px solid var(--dylo-line);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.Select_addInput__tKYZr {
  width: 100%;
  border: 1px solid var(--dylo-field-border);
  border-radius: 8px;
  padding: 7px 10px;
  background: var(--dylo-field-bg);
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  font-size: 13px;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Select/Select.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,kBAAkB;EAClB,uDAAwC;AAC1C;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,8EAAgE;AAClE;AACA;EACE,sBAAQ,eAAe,EAAE;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,kEAAkE;AACpE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qDAAuC;AACzC;AACA,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C,qCAAuB,sBAAsB,EAAE;AAC/C;EACE,wBAAU,eAAe,EAAE;AAC7B;AACA;EACE,qEAAqE;AACvE;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;sDAIsD;AACtD;EACE,gCAAgC;EAChC,mEAAmE;EACnE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,aAAa;AACf","sourcesContent":[".wrap {\n  position: relative;\n  width: 100%;\n}\n\n.control {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 40px;\n  padding: 8px 12px;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  color: var(--dylo-ink);\n  text-align: left;\n}\n.control:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.open .control {\n  border-color: var(--dylo-teal-500);\n}\n.placeholder {\n  color: var(--dylo-muted);\n}\n.value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.right {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  color: var(--dylo-field-icon);\n}\n.clear {\n  border: none;\n  background: none;\n  color: var(--dylo-field-icon);\n  cursor: pointer;\n  display: inline-flex;\n  padding: 2px;\n  border-radius: 4px;\n}\n.clear:hover {\n  color: var(--dylo-ink);\n}\n.chevron {\n  transition: transform 0.15s ease;\n}\n.open .chevron {\n  transform: rotate(180deg);\n}\n.spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid var(--dylo-line);\n  border-top-color: var(--dylo-teal-700);\n  border-radius: 50%;\n  animation: sel-spin 0.7s linear infinite;\n}\n@keyframes sel-spin {\n  to { transform: rotate(360deg); }\n}\n\n.menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 4px);\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 10px;\n  box-shadow: var(--shadow-card);\n  z-index: 40;\n  overflow: hidden;\n  transform-origin: top center;\n  animation: dylo-dropdown 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n@media (prefers-reduced-motion: reduce) {\n  .menu { animation: none; }\n}\n.search {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid var(--dylo-line);\n  padding: 9px 12px;\n  background: transparent;\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  outline: none;\n}\n.list {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.list::-webkit-scrollbar {\n  width: 6px;\n}\n.list::-webkit-scrollbar-track {\n  background: transparent;\n}\n.list::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.list::-webkit-scrollbar-thumb:hover {\n  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);\n}\n.option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  text-align: left;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  cursor: pointer;\n  border-radius: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  animation: dylo-fade-in 0.22s ease both;\n}\n.option:nth-child(1) { animation-delay: 0.02s; }\n.option:nth-child(2) { animation-delay: 0.04s; }\n.option:nth-child(3) { animation-delay: 0.06s; }\n.option:nth-child(4) { animation-delay: 0.08s; }\n.option:nth-child(5) { animation-delay: 0.10s; }\n.option:nth-child(6) { animation-delay: 0.12s; }\n.option:nth-child(7) { animation-delay: 0.14s; }\n.option:nth-child(8) { animation-delay: 0.16s; }\n@media (prefers-reduced-motion: reduce) {\n  .option { animation: none; }\n}\n.option:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);\n}\n.option > span:first-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.optionActive {\n  color: var(--dylo-orange);\n  font-weight: 600;\n}\n\n/* Opción visible pero no seleccionable (ej. proveedor sin acceso todavía) */\n.optionDisabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.optionDisabled:hover {\n  background: transparent;\n}\n.optionHint {\n  flex: none;\n  padding: 2px 7px;\n  border-radius: 999px;\n  border: 1px solid var(--dylo-line);\n  color: var(--dylo-muted);\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n/* Tono de aviso: para lo que sí funciona normalmente y está apagado AHORA.\n   En gris se confunde con \"nunca estuvo disponible\", y esa lectura manda a pedir\n   credenciales en lugar de revisar el interruptor.\n   ⚠️ La opacidad del renglón deshabilitado (0.5) apaga cualquier color, así que el\n   naranja se refuerza aquí para que siga leyéndose. */\n.optionHintWarn {\n  border-color: var(--dylo-orange);\n  background: color-mix(in srgb, var(--dylo-orange) 14%, transparent);\n  color: var(--dylo-orange);\n  opacity: 1;\n}\n.empty {\n  padding: 12px;\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 13px;\n}\n\n.addRow {\n  border-top: 1px solid var(--dylo-line);\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.addInput {\n  width: 100%;\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 8px;\n  padding: 7px 10px;\n  background: var(--dylo-field-bg);\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  font-size: 13px;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Select_wrap__EZXnk`,
	"control": `Select_control__cFvYI`,
	"open": `Select_open__nJ2M8`,
	"placeholder": `Select_placeholder__mHE91`,
	"value": `Select_value__R-nOD`,
	"right": `Select_right__JxoS3`,
	"clear": `Select_clear__+sbCE`,
	"chevron": `Select_chevron__zogbu`,
	"spinner": `Select_spinner__I9vi+`,
	"sel-spin": `Select_sel-spin__Ux4+X`,
	"menu": `Select_menu__4TqVa`,
	"dylo-dropdown": `Select_dylo-dropdown__gAlzZ`,
	"search": `Select_search__kB4Cj`,
	"list": `Select_list__Yluhs`,
	"option": `Select_option__Uivtz`,
	"dylo-fade-in": `Select_dylo-fade-in__VRT7I`,
	"optionActive": `Select_optionActive__eX-ae`,
	"optionDisabled": `Select_optionDisabled__df7vy`,
	"optionHint": `Select_optionHint__ouMbu`,
	"optionHintWarn": `Select_optionHintWarn__-YcRZ`,
	"empty": `Select_empty__XJeeZ`,
	"addRow": `Select_addRow__9yYde`,
	"addInput": `Select_addInput__tKYZr`
};
export default ___CSS_LOADER_EXPORT___;
